import { ROOT_URL as STRATEGY_V2_ROOT_URL } from "fleet/constant/media-library";
import osMetaMap from "fleet/constant/os-platform";
import React from "react";
import { Link } from "react-router-dom";
import * as Device from "redux-store/devices/selectors";
import { BooleanField } from "ui/boolean-field/boolean-field";
import { VIEW } from "view/views";

import DeviceTags from "./tags";

function formatAttributeList(osPlatform, systemManaged, venueSyncEnabled) {
  return (
    <ul className="attributes-list">
      <li>
        <p>OS: {formatOsBadge(osPlatform)}</p>
      </li>
      {venueSyncEnabled && (
        <li>
          <p>Ad Platform Synced: {formatSystemManaged(systemManaged)}</p>
        </li>
      )}
    </ul>
  );
}

function formatPrimaryLink(columnValue, row, _rowIndex, formatExtraData = "device_id") {
  const deviceId = row[formatExtraData];

  return (
    <Link to={`/devices/${deviceId}`} title={columnValue}>
      {columnValue}
    </Link>
  );
}

function formatNetworkLink(name, row) {
  return (
    <Link to={`/networks/${row.network_id}`} title={name}>
      {name}
    </Link>
  );
}

function formatOsBadge(osId) {
  if (!osId) {
    return "Unknown";
  }

  const osMeta = osMetaMap[osId] || { label: osId };

  return (
    <span className="os-badge label bg-aqua" title={osMeta.label}>
      {osMeta.iconClass ? (
        <i className={`fa ${osMeta.iconClass}`} aria-hidden="true" />
      ) : null}
      <span className="badge-label">{osMeta.label}</span>
    </span>
  );
}

function formatStrategyLink(name, row) {
  if (name && row.strategy_id > 0) {
    return (
      <Link
        to={`${STRATEGY_V2_ROOT_URL}/${row.strategy_id}/${VIEW.EDIT}`}
        title={name}
      >
        {name}
      </Link>
    );
  }

  return "N/A";
}

function formatSystemManaged(systemManaged) {
  return (
    <BooleanField
      value={systemManaged}
      title="Indicates whether device is synced with ad platform."
    />
  );
}

function formatTags(tags) {
  return <DeviceTags tags={tags} hideSystemTags={true} />;
}

function sortStatusIcon(d1, d2, order) {
  const multiplier = order === "desc" ? -1 : 1;
  const d1Value = Device.getStatus(d1).code;
  const d2Value = Device.getStatus(d2).code;

  if (d1Value > d2Value) {
    return multiplier;
  } else if (d2Value > d1Value) {
    return -1 * multiplier;
  }

  return 0;
}

export {
  formatAttributeList,
  formatNetworkLink,
  formatOsBadge,
  formatPrimaryLink,
  formatStrategyLink,
  formatSystemManaged,
  formatTags,
  sortStatusIcon,
};
